const cache = new Map();
export const readClusterCache = key => {
  try { return cache.get(key) || JSON.parse(sessionStorage.getItem(key) || 'null'); }
  catch { return cache.get(key) || null; }
};
export const saveClusterCache = (key, value) => {
  cache.set(key, value);
  try { sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* Memory cache remains available. */ }
};
export const clearClusterResults = () => {
  for (const key of cache.keys()) if (key.startsWith('cause-clusters:')) cache.delete(key);
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
      const key = sessionStorage.key(i);
      if (key?.startsWith('cause-clusters:')) sessionStorage.removeItem(key);
    }
  } catch { /* Browser storage may be disabled. */ }
};
